import { useTranslation } from 'react-i18next';
import { ImpersonateUserPanel } from '@/components/admin/ImpersonateUserPanel';

export default function ImpersonatePage(): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold text-foreground">{t('impersonate.title')}</h1>
        <p className="text-sm text-muted-foreground mt-1">{t('impersonate.subtitle')}</p>
      </div>

      <ImpersonateUserPanel />
    </div>
  );
}
